import { render, staticRenderFns } from "./approvePaymentList.vue?vue&type=template&id=51178169"
import script from "./approvePaymentList.vue?vue&type=script&lang=js"
export * from "./approvePaymentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports